import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Authorization from '../../Authentication/Authorization'
import { FlipCardContainer } from '../../components/FlipCard'
import ProtectedRoute from '../../components/ProtectedRoute'
import GatewayType from '../GatewayType'
import ActiveDirectory, { AdConfigFlipCard } from './ActiveDirectory'
import ActiveDirectoryMapping, { AdMappingFlipCard } from './ActiveDirectoryMapping'
import Administrator, { AdministratorFlipCard } from './Administrator'
import LoginDelay from './LoginDelay'
import PasswordPolicy from './PasswordPolicy'
import ProxyUsers from './ProxyUsers'
import Role, { RoleFlipCard } from './Role'

const baseRoute = '/userManagement'
const umPermission = Authorization.userManagement

const subTab = [
  { path: `${baseRoute}/administrator`, title: 'Administrator', permissions: umPermission.administration.viewAdmin, component: Administrator },
  { path: `${baseRoute}/role`, title: 'Role', permissions: umPermission.administration.viewRole, component: Role },
  { path: `${baseRoute}/passwordPolicy`, title: 'Password Policy', permissions: umPermission.passwordPolicy.view, component: PasswordPolicy },
  { path: `${baseRoute}/loginDelay`, title: 'Login Delay', permissions: umPermission.passwordPolicy.view, component: LoginDelay },
  { path: `${baseRoute}/activeDirectoryMapping`, title: 'AD Mapping', permissions: umPermission.adMapping, component: ActiveDirectoryMapping },
  { path: `${baseRoute}/proxyUsers`, title: 'Proxy Users', permissions: umPermission.policyUsers, component: ProxyUsers },
  { path: `${baseRoute}/activeDirectory`, title: 'Active Directory', permissions: umPermission.activeDirectory.view, component: ActiveDirectory },
]

const UserManagement: GatewayType = () => {
  const match = useRouteMatch()
  return (
    <Switch>
      {subTab.map((tab) => (
        <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
      ))}
      <Route path={match.path}>
        <FlipCardContainer>
          <AdministratorFlipCard />
          <RoleFlipCard />
          <AdConfigFlipCard />
          <AdMappingFlipCard />
        </FlipCardContainer>
      </Route>
    </Switch>
  )
}

UserManagement.subTabs = subTab

export default UserManagement
